module.exports = __webpack_public_path__ + "img/capture_1.816ab6c9.jpg";